<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1"><div class="block-rw dedication-rw" id="dedication1"><p class="ded-rw" id="p39"><span>To my family.</span></p><p class="ded-rw" id="p40"><span>You lift me up.</span></p><p class="ded-rw" id="p41"><span>You make me proud.</span></p><p class="ded-rw" id="p42"><span> </span></p><p class="ded-rw" id="p43"><span> </span></p><p class="ded-rw" id="p44"><span>And to Tom, always and forever.</span></p></div></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s003-Dedication-01.vue?2c28c520